import React, {Component} from 'react'
import PropTypes from 'prop-types'

class MarkerColumn extends Component {
    render() {
        const {marker} = this.props
        
        return <td className="marker">
            {marker}
        </td>
    }
}

MarkerColumn.propTypes = {
    marker: PropTypes.string,
}

export default MarkerColumn